export default {
	editButton: "Edit",
	editDisabled: "Opre was invited to this meeting via a calendar email. Please edit the event in your calendar, and Opre will sync your changes.",
};
